<!-- app.svelte -->

<script>
  import LoginPage from "./routes/LoginPage.svelte";
  import { Router, Route, Link } from "svelte-navigator";
  import MainScreen from "./routes/MainScreen.svelte";
  import { API_DIR, SESSION_LS, currentPage } from "./store";
  import { onMount } from "svelte";
  import { checkSessionExists } from "./Utils.svelte";

  // Código del Service Worker
  onMount(() => {
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/service-worker.js")
          .then((registration) => {
            console.log("Service Worker registrado con éxito:", registration);
          })
          .catch((error) => {
            console.log("Fallo en el registro del Service Worker:", error);
          });
      });
    }

    API_DIR.set(document.getElementById("api_dir").getAttribute("value"));
    let initialPage = "LOGIN_PAGE";

    let sessionID = localStorage.getItem($SESSION_LS);
    console.log("sessionID", sessionID);
    if (sessionID && sessionID.trim() !== "") {
      checkSessionExists(sessionID).then((sessionExists) => {
        console.log(sessionExists);
        if (sessionExists) {
          initialPage = "MAIN_PAGE";
        } else {
          initialPage = "LOGIN_PAGE";
        }
        currentPage.set(initialPage);
      });
    } else {
      currentPage.set(initialPage);
    }
  });
</script>

{#if $currentPage === "LOGIN_PAGE"}
  <LoginPage />
{:else if $currentPage === "MAIN_PAGE"}
  <MainScreen />
{/if}

<style>
  /* Estilos */
</style>
